import { defineMessages } from 'react-intl';

export default defineMessages({
  export: {
    id: 'export',
    defaultMessage: 'Export'
  },
});
